import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const memoryBankRetrieveStep = defineStepConfig({
  type: "memory_bank_retrieve",
  name: "Retrieve Memories",
  description:
    "Load the memory bank notes scoped to this workflow (stored via the Store Memory node or the workflow's Memories panel). Optionally rank by a query when the workflow has accumulated many memories.",
  category: "AI & Agents",

  experimental: {
    reason:
      "Workflow-scoped memories are under active development; storage and retrieval semantics may still change.",
  },

  inputSchema: z.object({
    query: z
      .string()
      .optional()
      .describe(
        "Optional free-text query used to rank memories by relevance when the workflow has many notes. Leave unset to get the most recent memories.",
      ),
  }),

  outputSchema: z.object({
    context: z
      .string()
      .describe(
        "All retrieved memories formatted as a single '[Note i] ...' block, ready to splice into a prompt. Empty string when the workflow has no memories.",
      ),
    notes: z
      .array(z.string())
      .describe("The retrieved memories as individual sanitized strings."),
    noteCount: z.number().describe("Number of memories retrieved."),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "1 minute",
    retry: {
      maximumAttempts: 2,
    },
  },
});
